import PassworReset from "./PasswordReset";

export default PassworReset;
